/** Shown on straight-bet dashboard when admin has not uploaded active banners. */
export const DEFAULT_PRIMARY_BANNERS = [
  { imgSrc: "sliderBannerImg1", title: "Promotions", linkUrl: "/info/promo" },
  { imgSrc: "sliderBannerImg2", title: "Features", linkUrl: "/info/features" },
  { imgSrc: "sliderBannerImg3", title: "FAQ", linkUrl: "/faq" },
  { imgSrc: "sliderBannerImg1", title: "How to bet", linkUrl: "/info/how-to" },
];

export const DEFAULT_SECONDARY_BANNERS = [
  { imgSrc: "sliderBanner2Img1" },
  { imgSrc: "sliderBanner2Img2" },
  { imgSrc: "sliderBanner2Img3" },
  { imgSrc: "sliderBanner2Img1" },
];
